<template>
  <div>
    <Table
      base-route="/brands"
      resource="MerchantV2"
      label="Brand"
      :actions="actions"
      :items="$store.getters['brandV2/tableData']"
      :detail="$store.getters['brandV2/detailData']"
      :detail-route="row => `/v2/brands/${row.id}/detail`"
      :fields="$store.getters['brandV2/tableFields']"
      :pagination="$store.state.brandV2.tablePagination"
      :keyword="$store.state.brandV2.tableKeyword"
      :loading="$store.state.brandV2.loadingTable"
      :filter="$store.state.brandV2.tableFilter"
      :sort="$store.state.brandV2.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />

    <b-modal
      v-if="canAccess('manage', 'MerchantV2')"
      id="modal-reset-password"
      title="Reset Password"
      ok-title="Ya, Yakin"
      cancel-title="Batalkan"
      :ok-disabled="isSubmitting"
      @hidden="dataToResetPassword = ''"
      @ok.prevent="reset"
    >
      <brand-detail
        v-if="dataToResetPassword"
        :data="dataToResetPassword"
      />
      <span v-if="dataToResetPassword">Tautan untuk mengatur ulang password akan dikirim ke email brand. Apakah anda yakin?</span>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import Table from '@/layouts/components/v2/Table.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BrandDetail from '@/views/brands/BrandDetail.vue'

export default {
  components: {
    BModal,
    Table,
    BrandDetail,
  },
  data() {
    return {
      dataToResetPassword: '',
      isSubmitting: false,
      // Sort options similar to Banner v2
      sortOptions: [
        {
          key: 'created_at',
          direction: 'desc',
          label: 'Terbaru',
          default: true,
        },
        {
          key: 'created_at',
          direction: 'asc',
          label: 'Terlama',
        },
        {
          key: 'name',
          direction: 'asc',
          label: 'Nama (A-Z)',
        },
        {
          key: 'name',
          direction: 'desc',
          label: 'Nama (Z-A)',
        },
        {
          key: 'brand_score',
          direction: 'desc',
          label: 'Skor (Tinggi ke Rendah)',
        },
        {
          key: 'brand_score',
          direction: 'asc',
          label: 'Skor (Rendah ke Tinggi)',
        },
        {
          key: 'affiliate_percentage',
          direction: 'desc',
          label: 'Aff % (Tinggi ke Rendah)',
        },
        {
          key: 'affiliate_percentage',
          direction: 'asc',
          label: 'Aff % (Rendah ke Tinggi)',
        },
      ],
      actions: [
        'create',
        'view',
        'update',
        {
          type: 'other',
          children: [
            {
              label: 'Unduh Produk',
              event: data => this.downloadProducts(data.item),
              visibility: {
                callback: () => this.canAccess('manage', 'MerchantV2'),
              },
            },
            {
              label: 'Reset Password',
              event: data => this.resetPassword(data.item),
              visibility: {
                callback: () => this.canAccess('manage', 'MerchantV2'),
              },
            },
          ],
        },
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('brandV2/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('brandV2/getDetail', id)
    },
    resetDetail() {
      this.$store.commit('brandV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('brandV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('brandV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('brandV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('brandV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('brandV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('brandV2/SET_TABLE_KEYWORD', val)
    },
    resetPassword(item) {
      this.dataToResetPassword = item
      this.$bvModal.show('modal-reset-password')
    },
    afterResetPassword() {
      this.$bvModal.hide('modal-reset-password')
      this.dataToResetPassword = ''
    },
    async reset() {
      this.isSubmitting = true

      const email = this.dataToResetPassword.email || this.dataToResetPassword.user?.email

      await this.$store.dispatch('brand/resetPassword', { email })
        .then(() => {
          this.afterResetPassword()
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    async downloadProducts(item) {
      try {
        const response = await this.$http.get(`/v2/admin/merchants/${item.id}/export-products`, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '')
        const timeStr = new Date().toLocaleTimeString('en-US', { hour12: false }).replace(/:/g, '')

        link.href = url
        link.setAttribute('download', `ekspor-produk-${item.name.replace(/\s+/g, '-').toLowerCase()}-${dateStr}-${timeStr}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sukses',
            icon: 'CheckIcon',
            text: 'Data produk berhasil diunduh.',
            variant: 'success',
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Gagal',
            icon: 'XIcon',
            text: 'Gagal mengunduh produk.',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>
